import { useAuth } from "@/auth";
import { Navigate, useSearchParams } from "react-router-dom";
import { LoginButton } from "@/components/auth/LoginButton";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Loading } from "@/components/ui/loading";
import { validateAndSanitizeReturnTo } from "@/utils/urlValidation";

/**
 * LoginPage Component
 *
 * Login page that displays Auth0 login button.
 * Redirects to home if already authenticated.
 */
export function LoginPage() {
  const { isAuthenticated, isLoading } = useAuth();
  const [searchParams] = useSearchParams();

  // If already authenticated, redirect to returnTo or home
  if (isAuthenticated) {
    const destination = validateAndSanitizeReturnTo(searchParams.get("returnTo"), "/");
    return <Navigate to={destination} replace />;
  }

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center space-y-2">
          <CardTitle className="text-3xl">Welcome to Vortal</CardTitle>
          <CardDescription className="text-base">
            Please sign in to continue to your account
          </CardDescription>
        </CardHeader>
        <CardContent className="flex justify-center">
          <LoginButton />
        </CardContent>
      </Card>
    </div>
  );
}
